var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPopular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_2482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5809 15.0756C19.5594 18.8936 16.4057 22 12.5507 22H11.4138C9.556 22 7.80323 21.2831 6.47831 19.9813C5.15064 18.6776 4.40708 16.9373 4.38358 15.0815C4.36252 13.3803 4.77466 11.5518 5.60901 9.64709L5.81623 9.17453L8.46836 9.94891C8.71067 7.5043 9.99561 5.28476 11.9818 3.8573C12.2766 3.6452 12.5872 3.4505 12.912 3.27518L15.2761 2L15.0005 4.42905C14.766 6.49539 15.5149 8.41342 17.0555 9.69257L17.0751 9.70859L17.1813 9.81357C18.8076 11.2023 19.5926 12.9238 19.5809 15.0756Z",
    fill: "#FFE532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5808 15.0756C19.5593 18.8936 16.4056 22 12.5507 22H11.9818V3.85745C12.2766 3.6452 12.5871 3.45065 12.9121 3.27518L15.276 2L15.0005 4.42905C14.7659 6.49539 15.5148 8.41342 17.0555 9.69257L17.075 9.70859L17.1812 9.81357C18.8075 11.2023 19.5926 12.9238 19.5808 15.0756Z",
    fill: "#FFBA36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0749 18.2457C16.0635 20.3157 14.3549 22 12.2662 22H11.6981C10.6915 22 9.74206 21.6116 9.02444 20.9065C8.30484 20.1997 7.90185 19.2566 7.88934 18.2507C7.87805 17.3581 8.09259 16.4032 8.5267 15.4123L8.73391 14.9393L9.98132 15.3033C10.2006 14.0686 10.9217 12.9704 11.9819 12.2794C12.0872 12.2104 12.1957 12.1458 12.3077 12.0856L13.9842 11.181L13.7829 12.9539C13.6756 13.9006 14.0034 14.7432 14.7065 15.3265L14.726 15.343L14.7805 15.397C15.6579 16.1494 16.0815 17.0818 16.0749 18.2457Z",
    fill: "#FF7816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 18.2457C16.0634 20.3157 14.3549 22 12.2661 22H11.9818V12.2794C12.0871 12.2104 12.1956 12.1458 12.3076 12.0856L13.9841 11.181L13.7828 12.9539C13.6755 13.9006 14.0033 14.7432 14.7064 15.3265L14.726 15.343L14.7804 15.397C15.6578 16.1494 16.0814 17.0818 16.0748 18.2457Z",
    fill: "#FE4B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_2482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopular);
export default __webpack_public_path__ + "static/media/icon_popular.952a80c20b04c15c62fbff25a9ff4005.svg";
export { ForwardRef as ReactComponent };